import styled, { createGlobalStyle } from 'styled-components';
import { surface, ink, border, focus } from '../UI/tokens';

export const GlobalModalStyle = createGlobalStyle`
  @media (min-width: 1200px) {
    .modal-xl .modal-dialog {
      max-width: 90vw !important;
    }
  }
`;

// X desenhado por CSS: independente do ícone de fundo e do filtro do Bootstrap.
export const CloseModalButton = styled.button`
  && {
    position: relative; display: inline-flex; flex: 0 0 34px;
    width: 34px; height: 34px; margin-left: auto; padding: 0;
    align-self: flex-start; border: 1px solid ${border}; border-radius: 8px;
    background: ${surface}; color: ${ink}; opacity: 1; cursor: pointer;
  }
  &::before, &::after {
    content: ''; position: absolute; top: 50%; left: 50%;
    width: 15px; height: 2px; background: currentColor; border-radius: 1px;
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &::after { transform: translate(-50%, -50%) rotate(-45deg); }
  &:hover { box-shadow: 0 0 0 3px rgba(128,145,167,.18); }
  ${focus}
`;
